import { IQuickSortState } from "../../IQuickSortState";
import { IQuickSortContext } from '../../IQuickSortContext';
import { QuickSortStep } from '../../enums/QuickSortStep';
import { assertIsDefined } from "../../../tsutils/assertIsDefined";
import { QuickSortCallPartitionState } from "./QuickSortCallPartitionState";
import { QuickSortReturnState } from "./QuickSortReturnState";


export class QuickSortCompareLowHighState implements IQuickSortState {

  ThisQuickSortStep = QuickSortStep.QuickSortCompareLowHigh;
  
  Description = "Compare Lo and Hi";

  private _savedState : { ComparisonResult: boolean } | undefined;

  private _context : IQuickSortContext | undefined;
  
  SetContext(context: IQuickSortContext): void {
    this._context = context;
  } 
  
  Do(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._context.Lo);
    assertIsDefined(this._context.Hi);

    let comparisonResult = this._context.Lo < this._context.Hi;

    if (this._savedState === undefined) {
      this._savedState = {
        ComparisonResult: comparisonResult
      }
    }
    else {
      this._savedState.ComparisonResult = comparisonResult;
    }

    //
    // probably need to save lo and hi and to set lo and hi
    // later ...
    //

  }

  Undo(): void {
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.ComparisonResult);
  }

  Exit(): void {
    assertIsDefined(this._context);
    assertIsDefined(this._savedState);
    assertIsDefined(this._savedState.ComparisonResult);

    if (this._savedState.ComparisonResult) {
      this._context.TransitionTo(new QuickSortCallPartitionState());
    }
    else {
      this._context.TransitionTo(new QuickSortReturnState());
    }
  }
}